class ExpectedFileForUpload {
  constructor(
    public name: string,
    public already_selected: boolean = false,
  ) {}
}

export default ExpectedFileForUpload;
